function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getCellSizes, getFixedCellSize } from '../../_table.utils';
export var _tableHeaderBaseCellTheme = {
  baseStyle: _ref => {
    var {
      size,
      textAlign,
      isSticky,
      left
    } = _ref;
    return _objectSpread(_objectSpread(_objectSpread({}, isSticky && {
      position: 'sticky',
      top: 0,
      left: "".concat(left, "px"),
      zIndex: 'docked',
      borderRight: 'basic.light'
    }), {}, {
      minHeight: '49px'
    }, getFixedCellSize(size)), {}, {
      textAlign,
      borderBottom: 'surface.empty',
      ':first-of-type': {
        borderTopLeftRadius: 'l',
        overflow: 'hidden'
      },
      ':last-of-type': {
        borderTopRightRadius: 'l',
        overflow: 'hidden'
      }
    });
  },
  variants: {
    light: {
      backgroundColor: 'neutral.white'
    },
    dark: {
      backgroundColor: 'neutral.lightest',
      color: 'neutral.darkest'
    }
  },
  sizes: getCellSizes(),
  defaultProps: {
    textAlign: 'start'
  }
};
//# sourceMappingURL=_TableHeaderBaseCell.theme.js.map